/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgHappening = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 30 30">
        <G fill="none" fill-rule="evenodd" stroke="#FFFFFF" transform="translate(1 1)">
            <Circle cx="14" cy="14" r="14"></Circle>
            <Path d="M14.0659938,21.4201083 C14.0659938,21.4201083 17.6583483,18.8401083 19.0659935,17.4201083 C22.2023469,14.2562271 22.5740309,8.42010825 18.0659941,8.42010825 C15.6670387,8.42010825 14.6757282,9.65010825 14.0659938,10.6001083 C13.4562593,9.65010825 12.4649492,8.42010825 10.0659939,8.42010825 C5.55795698,8.42010825 5.91620798,14.2426769 9.06599387,17.4201083 C10.4736391,18.8401083 14.0659938,21.4201083 14.0659938,21.4201083 Z"></Path>
        </G>
    </Svg>)
}

